module.exports = __webpack_public_path__ + "static/products-grid1-4d06c3734be9ff5220b79ddf8e62eed9.jpg";